const TextAreaBox = ({ title, placeholder = null, value, onChange, disabled = false, cols = '30', rows = '10' }) => {
    return (
        <div className='form-box'>
            <div className='input-box input-box-txt'>
                <label htmlFor={title}>{title}</label>
                <div className='input-group'>
                    <textarea
                        id={title}
                        cols={cols}
                        rows={rows}
                        disabled={disabled}
                        placeholder={placeholder && placeholder}
                        onChange={(e) => onChange(e)}
                        value={value}
                    />
                </div>
            </div>
        </div>
    );
};

export default TextAreaBox;
